import instance from '@apis/instance';

class UserEventApi {
  static updateDau(projectId: string): Promise<never> {
    return instance.put('/events/user/active', { projectId });
  }
}

export default UserEventApi;
